import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectiveProcessPageComponent } from './pages/selective-process-page/selective-process-page.component';
import { GetApplymentService } from 'src/app/core/services/client-general-settings/applyment/get-applyment.service';

const routes: Routes = [
  {
    path: '',
    component: SelectiveProcessPageComponent,
    resolve: {
      applymentData: GetApplymentService,
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [],
  declarations: [],
})
export class SelectiveProcessRoutingModule { }
